export default [
    {
        chave: 'EDITAL',
        label: 'Edital'
    },
    {
        chave: 'ANEXO',
        label: 'Anexo'
    },
    {
        chave: 'ANEXO_IRP',
        label: 'Anexo de IRP'
    },
    {
        chave: 'ANTEPROJETO',
        label: 'Anteprojeto'
    },
    {
        chave: 'ATA',
        label: 'Ata',
    },
    {
        chave: 'ATO_AUT_CONTRAT_DIRETA',
        label: 'Ato que autoriza a Contratação Direta'
    },
    {
        chave: 'AUT_FORM_DEMANDA',
        label: 'Autorização de Formalização de Demanda'
    },
    {
        chave: 'AVISO_ABERTURA',
        label: 'Aviso de Abertura'
    },
    {
        chave: 'AVISO_CONTRAT_DIRETA',
        label: 'Aviso de Contratação Direta'
    },
    {
        chave: 'AVISO_LICITACAO',
        label: 'Aviso de Licitação'
    },
    {
        chave: 'AVISO_PRORROGACAO',
        label: 'Aviso de Prorrogação'
    },
    {
        chave: 'AVISO_PROSSEGUIMENTO',
        label: 'Aviso de Prosseguimento'
    },
    {
        chave: 'AVISO_REPETICAO',
        label: 'Aviso de Repetição'
    },
    {
        chave: 'AVISO_SUSPENSAO',
        label: 'Aviso de Suspensão'
    },
    {
        chave: 'AVISO_ANULACAO',
        label: 'Aviso de Anulação'
    },
    {
        chave: 'AVISO_CONTINUIDADE',
        label: 'Aviso de Continuidade'
    },
    {
        chave: 'AVISO_REVOGACAO',
        label: 'Aviso de Revogação'
    },
    {
        chave: 'ADENDO',
        label: 'Adendo'
    },
    {
        chave: 'ATA_REGISTRO_PRECO',
        label: 'Ata de Registro de Preço'
    },
    {
        chave: 'AVISO',
        label: 'Aviso'
    },
    {
        chave: 'COMUNICADO',
        label: 'Comunicado'
    },
    {
        chave: 'CONTRA_RECURSO',
        label: 'Contra-recurso'
    },
    {
        chave: 'CONTRARRAZAO',
        label: 'Contrarrazão'
    },
    {
        chave: 'CONTRATO',
        label: 'Contrato'
    },
    {
        chave: 'DECISAO_MODALIDADE',
        label: 'Decisão de Modalidade'
    },
    {
        chave: 'DECISAO',
        label: 'Decisão',
    },
    {
        chave: 'DESPACHO',
        label: 'Despacho'
    },
    {
        chave: 'DOD',
        label: 'DOD'
    },
    {
        chave: 'DESPACHO_SUPERINTENDENTE',
        label: 'Despacho do Superintendente'
    },
    {
        chave: 'ESTUDO_TECNICO_PRELIMINAR',
        label: 'Estudo Técnico Preliminar'
    },
    {
        chave: 'ESCLARECIMENTO',
        label: 'Esclarecimento'
    },
    {
        chave: 'IMPUGNACAO',
        label: 'Impugnação'
    },
    {
        chave: 'MAPA_ESTIMATIVO',
        label: 'Mapa Estimativo'
    },
    {
        chave: 'MAPA_GESTAO_RISCO',
        label: 'Mapa de Gestão de Risco'
    },
    {
        chave: 'MINUTA_CONTRATO',
        label: 'Minuta do Contrato'
    },
    {
        chave: 'MINUTA_EDITAL',
        label: 'Minuta do Edital'
    },
    {
        chave: 'MODELO_DECLARACAO',
        label: 'Modelo de Declaração'
    },
    {
        chave: 'NOTA_EMPENHO',
        label: 'Nota de Empenho'
    },
    {
        chave: 'OFICIO',
        label: 'Ofício'
    },
    {
        chave: 'ORCAMENTO',
        label: 'Orçamento'
    },
    {
        chave: 'PARECER_TECNICO',
        label: 'Parecer Técnico'
    },
    {
        chave: 'PARECER_JURIDICO',
        label: 'Parecer Jurídico'
    },
    {
        chave: 'PEDIDO_UTILIZACAO_ATA',
        label: 'Pedido de Utilização de Ata'
    },
    {
        chave: 'PLANO_TRABALHO',
        label: 'Plano de Trabalho'
    },
    {
        chave: 'PROJETO_BASICO',
        label: 'Projeto Básico'
    },
    {
        chave: 'PROJETO_EXECUTIVO',
        label: 'Projeto Executivo'
    },
    {
        chave: 'PROPOSTA_COMERCIAL',
        label: 'Proposta Comercial'
    },
    {
        chave: 'PROPOSTA_DETALHE',
        label: 'Proposta Detalhe',
    },
    {
        chave: 'PUBLICACAO',
        label: 'Publicação'
    },
    {
        chave: 'RECURSOS',
        label: 'Recursos'
    },
    {
        chave: 'RESP_PARECER_JURIDICO',
        label: 'Resposta ao Parecer Jurídico'
    },
    {
        chave: 'RESPOSTA_DECISAO_IMPUG',
        label: 'Resposta a Decisão de Impugnação'
    },
    {
        chave: 'RESPOSTA_PEDIDO_ESCLAR',
        label: 'Resposta a Pedido de Esclarecimento'
    },
    {
        chave: 'RESPOSTA_PEDIDO_IMPUG',
        label: 'Resposta a Pedido de Impugnação'
    },
    {
        chave: 'RESPOSTA_RECURSO',
        label: 'Resposta ao Recurso'
    },
    {
        chave: 'RES_ANALISE_AMOSTRA',
        label: 'Resultado de Análise de Amostras'
    },
    {
        chave: 'RESULTADO_LICITACAO',
        label: 'Resultado de Licitação'
    },
    {
        chave: 'SOLICITACAO_COMPRA',
        label: 'Solicitação de Compras'
    },
    {
        chave: 'SOLICITACAO_COMPRA_TI',
        label: 'Solicitação de Compras TI'
    },
    {
        chave: 'SOLICITACAO_EMPENHO',
        label: 'Solicitação de Empenho'
    },
    {
        chave: 'SOLICITACAO_PESQ_PRECO',
        label: 'Solicitação de Pesquisa de Preço'
    },
    {
        chave: 'SOL_PREEMPENHO_EMPENHO',
        label: 'Solicitação de Pré Empenho e Empenho'
    },
    {
        chave: 'TERMO_REFERENCIA',
        label: 'Termo de Referência'
    },
    {
        chave: 'TERMO_DESENTRANHAMENTO',
        label: 'Termo de Desentranhamento',
        oculto: true
    },
    {
        chave: 'TERMO_HOMOLOGACAO',
        label: 'Termo de Homologação',
    },
    {
        chave: 'RELATORIO_RECURSO',
        label: 'Relatório de Recurso',
    },
    {
        chave: 'RELATORIO_CONTRARRAZAO',
        label: 'Relatório de Contrarrazão',
    },
    {
        chave: 'ANEXO_DE_EDITAL_DE_LICITACAO',
        label: 'Anexo de Edital de Licitação',
    },
    {
        chave: 'OUTROS',
        label: 'Outros'
    },
    {
        chave: 'MAPA_DE_RISCOS',
        label: 'Mapa de Riscos'
    },
    {
        chave: 'TERMO_RESCISAO',
        label: 'Termo de Rescisão'
    },
    {
        chave: 'TERMO_ADITIVO',
        label: 'Termo Aditivo'
    },
    {
        chave: 'TERMO_APOSTILAMENTO',
        label: 'Termo de Apostilamento'
    },
    {
        chave: 'TEXTO_DE_CONVENIO',
        label: 'Texto de Convênio ou Aditivo ao Convênio'
    },
    {
        chave: 'ATA_DE_JULGAMENTO_DA_PROPOSTA_TECNICA',
        label: 'Ata de julgamento da Proposta Técnica'
    },
    {
        chave: 'ATA_DE_JULGAMENTO_DA_HABILITACAO',
        label: 'Ata de julgamento da Habilitação/Proposta de Preços'
    },
    {
        chave: 'ART',
        label: 'ART'
    },
    {
        chave: 'AVALIACAO_PREVIA',
        label: 'Avaliação prévia'
    },
    {
        chave: 'DOCUMENTOS_E_PLANILHAS_DESENVOLVIDOS_PARA_AVALIACAO_ECONOMICO_FINANCEIRA',
        label: 'Documentos e planilhas desenvolvidos para avaliação econômico-financeira'
    },
    {
        chave: 'ESPECIFICACAO_NORMAS_E_COMO_CRITERIO_DE_MEDICAO',
        label: 'Especificação, normas e como critério de medição'
    },
    {
        chave: 'ESPECIFICACOES_COMPLEMENTARES_E_AS_NORMAS',
        label: 'Especificações complementares e as normas'
    },
    {
        chave: 'ESTUDOS_E_LICENCAS_AMBIENTAIS',
        label: 'Estudos e licenças ambientais'
    },
    {
        chave: 'LEI_AUTORIZATIVA',
        label: 'Lei autorizativa'
    },
    {
        chave: 'PARAMETRO_OU_INDICADOR_DA_AFERICAO_DO_EQUILIBRIO_ECONOMICO_FINANCEIRO',
        label: 'Parâmetro ou indicador da aferição do equilíbrio econômico-financeiro'
    },
    {
        chave: 'LICENCA_AMBIENTAL_PREVIA_OU_DIRETRIZ_PARA_O_LICENCIAMENTO_AMBIENTAL',
        label: 'Licença ambiental prévia ou diretriz para o licenciamento ambiental'
    },
    {
        chave: 'DISCRIMINACAO_DOS_BENS_REVERSIVEIS',
        label: 'Discriminação dos bens reversíveis'
    },
    {
        chave: 'DESIGN_DE_SOFTWARE',
        label: 'Design de Software'
    },
    {
        chave: 'RAZAO_DE_ESCOLHA_DO_CONTRATADO',
        label: 'Razão de escolha do contratado'
    },
    {
        chave: 'JUSTIFICATIVA_DO_PRECO',
        label: 'Justificativa do preço'
    },
    {
        chave: 'AUTORIZACAO_DA_AUTORIDADE_COMPETENTE',
        label: 'Autorização da autoridade competente'
    },
    {
        chave: 'CERTIFICACAO_DE_INEXISTENCIA_DE_IMOVEIS_PUBLICOS_VAGOS_E_DISPONIVEIS',
        label: 'Certificação de inexistência de imóveis públicos vagos e disponíveis'
    },
    {
        chave: 'JUSTIFICATIVA_DE_SINGULARIDADE',
        label: 'Justificativa de singularidade'
    },
    {
        chave: 'CARACTERIZACAO_DA_SITUACAO_EMERGENCIAL_OU_CALAMITOSA',
        label: 'Caracterização da situação emergencial ou calamitosa'
    },
    {
        chave: 'COMUNICACAO_E_RATIFICACAO',
        label: 'Comunicação e ratificação'
    },
    {
        chave: 'TEXTO_DE_EDITAL_CONVITE_DISPENSA_OU_INEXIGIBILIDADE_DE_LICITACAO',
        label: 'Texto de Edital Convite Dispensa ou Inexigibilidade de Licitacao'
    },
    {
        chave: 'JUSTIFICATIVA_DE_DISPENSA_INEXIGIBILIDADE',
        label: 'Justificativa de Dispensa Inexigibilidade'
    }
]
